import { defineStore } from 'pinia'

interface UserState {
  isLoggedIn: boolean | null
  nexonTag: string
}
export const useUserStore = defineStore('User', {
  state: (): UserState => ({
    isLoggedIn: null,
    nexonTag: '',
  }),
  actions: {
    getUserInfo(): Promise<void> {
      return new Promise((resolve) => {
        let numberOfcheck = 0
        const checkUserStatus = setInterval(() => {
          // window.Gnb.$store.state.isLoggedIn
          if (window.nexon.sso !== undefined || numberOfcheck > 20) {
            clearInterval(checkUserStatus)
            if (window.nexon.sso !== undefined) {
              this.isLoggedIn = window.nexon.sso.isLoggedIn
              this.nexonTag = window.nexon.sso.nexonTag ? window.nexon.sso.nexonTag : ''
              resolve()
            }
          }
          numberOfcheck++
        }, 500)
      })
    },
  },
})
